//React
import React, { useState } from "react";

// Axios
import axios from "axios";

//Global Assets
import Global from "../../Global";
import DarkButton from "../../Global/DarkButton";
import Colors from "../../Global/colors";
import background from "../../Assets/background.jpg";
import leftBackground from "../../Assets/left_background.png";
import apple from "../../Assets/apple_store.png";
import google from "../../Assets/Google_play.png";
import web from "../../Assets/web_apps.png";
import emailImg from "../../Assets/email.png";

//Custom Components
import swal from "@sweetalert/with-react";

//React Router
import { useHistory, Link } from "react-router-dom";

//Material UI Components
import {
  Grid,
  Typography,
  Paper,
  InputAdornment,
  TextField,
  CircularProgress,
} from "@material-ui/core";

//Responsive Carousel
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

//Redux
import { useSelector, useDispatch } from "react-redux";

//translation
import { useTranslation } from "react-i18next";

//Custom CSS
import "./forgotPassword.css";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2),
    textAlign: "center",
    marginTop: 40,
  },
  textField: {
    borderColor: Colors.globalColor4,
    backgroundColor: Colors.globalColor5,
    borderRadius: 5,
  },
  resize: {
    fontSize: 14,
  },
}));


//Main Function Start
export default function ForgotPassword() {
  let {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const history = useHistory();
  let [btnLoader, setBtnLoader] = useState(false);


  
  function handleSubmit(e) {
    e.preventDefault();
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false ||
      email.length == 0
    ) {
      swal(t("Warning"), t("Please Enter a Valid Email Format"), "warning");
      setBtnLoader(false);
      return;
    }

    axios
      .post(Global + "/forgot_password", { email,url:window.location.origin + "/changePassword" })
      .then(function(response) {
        console.log(response);
        if (response.data.status == "Success") {
          swal(
            t("Success"),
            t("An email was sent along with a reset password link"),
            "success"
          );
          setBtnLoader(false);
          setEmail("");
        } else {
          swal(t("Warning"), response.data.err, "warning");
          setBtnLoader(false);
        }
      })
      .catch(function(error) {
        console.log(error);
        setBtnLoader(false);
      });
  }


  return <div style={{ backgroundImage: `url(${background})`, height: "100vh", overflow: "scroll", display: "flex", justifyContent: "center", alignItems: "center", padding: "auto", overflow: "auto" }}>
      <div>

      {window.innerWidth > 700 && <>
        <Paper className="mainBox" elevation={3} style={{ margin: "5%", overflow: "hidden" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7} order={{ md: 2, lg: 1 }}>
              <div style={{ padding: 30, height: "100%" }}>
                <form onSubmit={handleSubmit} style={{ height: "100%" }}>
                  <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", justifyContent: "space-between" }}>
                    <div style={{ flex: 1 }}>
                      <h3 className="header1"> {t("Reset Via Email")}</h3>
                      <p className="subHeader1">
                        {t("Please enter the email Address you used when creating your account. We will send you instructions to reset your password")}
                      </p>
                      <br />

                      <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} sm={11}>
                          <TextField className={classes.textField} placeholder={t("Email Address")} fullWidth id="outlined-size-small" value={email} onChange={(e) => {
                              setEmail(e.target.value);
                            }} InputProps={{ startAdornment: <InputAdornment position="start">
                                  <img src={emailImg} width={14} />
                                </InputAdornment>, classes: { input: classes.resize } }} variant="outlined" size="small" />
                        </Grid>
                        <Grid item>
                          <DarkButton type={"submit"} fullWidth style={{ height: 40, backgroundColor: Colors.globalColor8, padding: "5px 20px" }} onClick={(e) => {
                              if (btnLoader == false) {
                                setBtnLoader(true);
                                handleSubmit(e);
                              }
                            }}>
                            {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}
                            {t("Send Link")}
                          </DarkButton>
                        </Grid>
                      </Grid>
                    </div>
                    <br />
                    <div style={{ flex: 1, display: "inline-flex", flexDirection: "column", justifyContent: "flex-end" }}>
                      <Typography variant="p">
                       {t("Recieved a link?")} <Link to="/signin" style={{ color: Colors.globalColor8 }}>
                          {t("Signin")}
                        </Link>
                      </Typography>
                    </div>
                  </div>
                </form>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5} xl={5} style={{ padding: "30px 30px", backgroundImage: `url(${leftBackground})`, backgroundSize: "contain" }} order={{ md: 1, lg: 2 }}>
              <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", justifyContent: "space-between" }}>
                <div style={{ flex: 1 }}>
                  <Carousel interval={5000} autoPlay={true} infiniteLoop={true} showIndicators={false} showStatus={false} showArrows={false} style={{ backgroundColor: "green", paddingRight: "10%" }}>
                    <div style={{ textAlign:language =="ar" ? "right" : "left" }}>
                      <p className="subTitle">
                      {t("Paperless inspections, audits, custom reports, detail dashboards and team collaborations from anywhere and anytime.")}
                      </p>
                      <h3 className="title">
                        {t("Digital Platform Unlimited Possibilities")}
                      </h3>
                    </div>
                    <div style={{ textAlign:language =="ar" ? "right" : "left" }}>
                      <p className="subTitle">
                        {t("Empowering real-time visibility with a simple interface, smart operations and initiative functions.")}
                      </p>
                      <h3 className="title">{t("Start Saving Time and Money")}</h3>
                    </div>
                    <div style={{ textAlign:language =="ar" ? "right" : "left" }}>
                      <p className="subTitle">
                        {t("Detect, manage and avoid potential risks with multiple pictures and videos evidences.")}
                      </p>
                      <h3 className="title">{t("Enterprise Risk Management")}</h3>
                    </div>
                  </Carousel>
                </div>

                <div style={{ flex: 1, display: "inline-flex", flexDirection: "column", justifyContent: "flex-end" }}>
                  <p className="avaliblity">{t("Available On")}</p>
                  <Grid container spacing={1} alignItems="flex-start" justify="flex-start">
                    <Grid item>
                      <a href="https://play.google.com/store/apps/details?id=com.uraudit" target="blank">
                        <img src={google} width={50} />
                      </a>
                      <p className="avaliblity_item">Google Play</p>
                    </Grid>
                    <Grid item>
                      <a href="https://apps.apple.com/gb/app/uraudits/id1537135664" target="blank">
                        <img src={apple} width={50} />
                      </a>
                      <p className="avaliblity_item">Apple Store</p>
                    </Grid>
                    <Grid item>
                      <a href="/" target="blank">
                        <img src={web} width={50} />
                      </a>
                      <p className="avaliblity_item">Web Apps</p>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </Paper>
        <p className="copyright">
          {t("Copyright 2022 UrAudits.com All Rights Reserved")}
        </p>
        </>}

        {window.innerWidth <= 700 && <>
        <Paper className="mainBox" elevation={3} style={{ margin: "5%", overflow: "hidden" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7} order={{ md: 2, lg: 1 }}>
              <div style={{ padding: 30, height: "100%" }}>
                <form onSubmit={handleSubmit} style={{ height: "100%" }}>
                  <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", justifyContent: "space-between" }}>
                    <div style={{ flex: 1 }}>
                      <h3 className="header1"> {t("Reset Via Email")}</h3>
                      <p className="subHeader1">
                        {t("Please enter the email Address you used when creating your account. We will send you instructions to reset your password")}
                      </p>
                      <br />

                      <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} sm={11}>
                          <TextField className={classes.textField} placeholder="Email Address" fullWidth id="outlined-size-small" value={email} onChange={(e) => {
                              setEmail(e.target.value);
                            }} InputProps={{ startAdornment: <InputAdornment position="start">
                                  <img src={emailImg} width={14} />
                                </InputAdornment>, classes: { input: classes.resize } }} variant="outlined" size="small" />
                        </Grid>
                        <Grid item>
                          <DarkButton type={"submit"} fullWidth style={{ height: 40, backgroundColor: Colors.globalColor8, padding: "5px 20px" }} onClick={(e) => {
                              if (btnLoader == false) {
                                setBtnLoader(true);
                                handleSubmit(e);
                              }
                            }}>
                            {btnLoader == true && <CircularProgress size={18} style={{width:'100%', color: "white", marginRight: 7 }} />}
                            {t("Send Link")}
                          </DarkButton>
                        </Grid>
                      </Grid>
                    </div>
                    <br />
                    <div style={{ flex: 1, display: "inline-flex", flexDirection: "column", justifyContent: "flex-end" }}>
                      <Typography variant="p">
                        {t("Recieved a link?")} <Link to="/signin" style={{ color: Colors.globalColor8 }}>
                          {t("Signin")}
                        </Link>
                      </Typography>
                    </div>
                  </div>
                </form>
              </div>
            </Grid>
          
          </Grid>
        </Paper>
        <p className="copyright2">
          {t("Copyright 2022 UrAudits.com All Rights Reserved")}
        </p>
        </>}


      </div>
    </div>;

    // </div>
    // <form onSubmit={handleSubmit}>
    //   <Grid
    //     container
    //     direction="row"
    //     justify="center"
    //     alignItems="center"
    //     style={{ backgroundColor: "#e5f5fe", height: "100vh" }}
    //   >
    //     <Grid item xs={10} md={8}>
    //       <Paper className={classes.root} variant="outlined">
    //         <Grid item xs={12}>
    //           <img
    //             src={"images/logo_signin_new.png"}
    //             height={55}
    //             style={{ marginTop: 20, marginBottom: 20 }}
    //           />
    //         </Grid>
    //         <Grid
    //           item
    //           xs={12}
    //           style={{
    //             fontSize: 20,
    //             fontWeight: "bold",
    //             color: "#1c507b",
    //             marginBottom: 10,
    //           }}
    //         >
    //           Forgot Your Password?
    //         </Grid>
    //         <Grid item xs={12}>
    //           <Typography component="p" style={{ color: "#868686" }}>
    //             Enter your email address and we will send you a email to reset
    //             your password.
    //           </Typography>
    //         </Grid>
    //         {/* <Typography component="p" style={{ textAlign: 'start', marginTop: 15, color: '#6d7987' }}>Email address</Typography> */}
    //         <Grid
    //           container
    //           direction="row"
    //           justify="center"
    //           alignItems="center"
    //           spacing={2}
    //           style={{ marginTop: 15 }}
    //         >
    //           <Grid item>
    //             <TextField
    //               label="Email Address"
    //               id="outlined-size-small"
    //               value={email}
    //               onChange={(e) => {
    //                 setEmail(e.target.value);
    //               }}
    //               // defaultValue="Small"
    //               // style={{ textAlign: 'start' }}
    //               variant="outlined"
    //               // style={{ width: 300 }}
    //               size="small"
    //             />
    //           </Grid>
    //           <Grid item>
    //               <DarkButton
    //                 type={"submit"}
    //                 fullWidth
    //                 style={{ height: 40 }}
    //                 onClick={(e) => {
    //                   if (btnLoader == false) {
    //                     setBtnLoader(true);
    //                     handleSubmit(e);
    //                   }
    //                 }}
    //               >
    //                 {btnLoader == true && (
    //                   <CircularProgress
    //                     size={18}
    //                     style={{ color: "white", marginRight: 7 }}
    //                   />
    //                 )}
    //                 Reset Password
    //               </DarkButton>

    //           </Grid>
    //           <Grid item xs={8}>
    //           <Link
    //               href="#"
    //               onClick={(e) => {
    //                 e.preventDefault();
    //                 history.goBack();
    //               }}
    //             >
    //               Go Back
    //             </Link>
    //           </Grid>
    //         </Grid>
    //         <div>
    //           <br />
    //         </div>
    //         <div>
    //           <br />
    //         </div>
    //         <div>
    //           <br />
    //         </div>
    //       </Paper>
    //       <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
    //         <Typography component="p" style={{ color: "#868686" }}>
    //           Copyright 2020 UrAudits.com. All Rights Reserved
    //         </Typography>
    //       </Grid>
    //     </Grid>
    //   </Grid>
    // </form>
}
